import type { NextPage, NextPageContext } from "next";
import { getProductMenu } from "@libraries/api/product-menu/product-menu.repos";
import { TProductIconData } from "@layouts/Main/lib/Header/lib/MenuProduct/type";
import TermsContainers from "@containers/Policy/Terms";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { localeKey } from "@constants/locale-key";
import { getPolicy } from "@libraries/api/policy/policy.repos";

export interface IPropsPagePrivacyPolicy {
  dataPolicy: {
    content: string;
    toc: string[];
  };
  dataNavbar: TProductIconData[];
}

const Terms: NextPage<IPropsPagePrivacyPolicy> = (props) => {
  return (
    <>
      <TermsContainers dataNavbar={props.dataNavbar} dataPolicy={props.dataPolicy} />
    </>
  );
};

export const getServerSideProps = async (context: NextPageContext) => {
  const { data: dataProductMenu } = await getProductMenu({ level: 0 }, `${context.locale}`);
  const { data: dataPolicyResp } = await getPolicy('terms');

  return {
    props: {
      ...(await serverSideTranslations(context.locale ?? "id", localeKey)),
      title: "Syarat dan Ketentuan",
      description: "Syarat dan Ketentuan",
      imageUrl: "",
      dataNavbar: dataProductMenu as TProductIconData[],
      dataPolicy: dataPolicyResp,
    },
  };
};

export default Terms;
